// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-collection-structure-dialog__filters {
  margin-bottom: 12px;
}
.dl-collection-structure-dialog__footer-buttons {
  display: flex;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/CollectionsStructure/CollectionStructureDialog/CollectionStructureDialog.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR;AAGI;EACI,aAAA;EACA,SAAA;AADR","sourcesContent":[".dl-collection-structure-dialog__filters {\n  margin-bottom: 12px;\n}\n.dl-collection-structure-dialog__footer-buttons {\n  display: flex;\n  gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
